module.exports = __webpack_public_path__ + "static/media/laptop.3485358a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/laptop.png
// module id = 2013
// module chunks = 0